<template>
  <div class="sidebar-button-container">
    <v-layout
      v-if="!isMultiSelect"
      justify-center
      align-center
      :disabled="disabled"
      @click="onclick"
      @mouseover="animationEnter"
      @mouseleave="animationLeave"
      class="sidebar-button"
      :style="{ cursor: buttonIsDisabled ? 'inherit' : 'pointer' }"
    >
      <v-icon v-if="icon" :disabled="disabled" :color="iconColor" size="25px">
        {{ icon }}
      </v-icon>
    </v-layout>

    <transition name="fadeHeightSideBar" mode="out-in">
      <div v-if="hoverState" class="sidebar-button-hover">
        <div class="button-label">{{ buttonName }}</div>

        <dev-tag
          v-if="dev"
          position="relative"
          :style="{ zoom: '80%', 'margin-left': '10px' }"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import DevTag from "../../_Atoms/DevTag";

export default {
  components: { DevTag },

  props: {
    buttonName: {
      type: String,
      required: true
    },

    windowName: {
      type: String,
      required: false
    },

    windowType: {
      type: String,
      required: false
    },

    dev: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    icon: {
      type: String,
      required: true
    },

    isMultiSelect: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      toggleState: false,
      hoverState: false
    };
  },

  computed: {
    openedSidebar() {
      return this.$store.getters.getCurrentlyOpenHomeSidebar;
    },

    sidebarEnabled() {
      return this.$store.getters.isHomeSidebarEnabled;
    },

    isToolActionActive() {
      return this.$store.getters.tools_selectedAction === this.windowName;
    },

    buttonIsDisabled() {
      return !this.sidebarEnabled || this.dev || this.disabled;
    },

    buttonIsActive() {
      if (this.windowName === "measure") {
        return this.$store.getters.isMeasurementsToolbarOpen || this.hoverState;
      } else if (this.windowName === "heatmap") {
        return this.$store.getters.isShowHeatmap || this.hoverState;
      }
      return this.hoverState || this.toggleState || this.isToolActionActive;
    },

    iconColor() {
      if (this.buttonIsDisabled) {
        return "secondary darken-1";
      } else if (this.windowName === "print" && !this.isToTakePrint) {
        return "#767676";
      } else if (
        this.buttonIsActive ||
        (this.windowName === "measure" &&
          this.$store.getters.isMeasurementsToolbarOpen) ||
        (this.windowName === "heatmap" && this.$store.getters.isShowHeatmap)
      ) {
        return "accent";
      }
      return "#767676";
    },

    isToTakePrint() {
      return !!this.$store.getters.isToTakePrint;
    }
  },

  watch: {
    openedSidebar(sidebar) {
      if (this.windowType === "sidebar") {
        this.toggleState = this.windowName === sidebar;
      }
    }
  },

  methods: {
    onclick() {
      if (!this.dev && !this.disabled) {
        if (this.windowType === "tab" && this.sidebarEnabled) {
          this.$emit("openTab", this.windowName);
        } else if (this.windowType !== "tab" && this.sidebarEnabled) {
          this.toggleState = !this.toggleState;
          this.openSidebar();
        }
      }
      this.animationLeave();
    },

    openSidebar() {
      this.$emit("openSidebar", this.toggleState ? this.windowName : "");
    },

    animationEnter() {
      if (this.sidebarEnabled) {
        this.hoverState = true;
      }
    },

    animationLeave() {
      if (this.sidebarEnabled) {
        this.hoverState = false;
      }
    }
  }
};
</script>

<style scoped>
.sidebar-button-container {
  width: 40px;
  height: 30px;
  margin-top: 18px;
}

.sidebar-button {
  width: 40px;
  height: 40px;
  z-index: 12;
  position: relative;
}
.sidebar-button:hover {
  transition: all 0.3s;
}

.sidebar-button-hover {
  width: auto;
  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  position: fixed;
  margin-top: -36px;
  transition: 1s;
  padding: 0 8px 0 40px;
  border-radius: 5px;
  border: 1px solid var(--primary-dark);
  box-shadow: var(--sidebar-menu-hover-shadow);
}
.sidebar-button-hover .button-label {
  color: black;
  line-height: 36px;
  font-size: 12px;
  font-weight: 700;
  text-indent: 5px;
  white-space: nowrap;
}

.fadeHeightSideBar-enter-active,
.fadeHeightSideBar-leave-active {
  transition: all 0.3s;
}
.fadeHeightSideBar-enter,
.fadeHeightSideBar-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/SideBar/SidebarButton.vue